var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.comp,_vm._b({ref:"graphic",tag:"component"},'component',_vm.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }